import React from "react";
import { logout } from "@/lib/actions/logout.action";

export default function Logout() {
  return (
    <form action={logout}>
      <button className="text-gray-700 hover:text-white text-left px-4 py-2 text-sm w-full hover:bg-red-500 rounded-b-lg">
        Logout
      </button>
    </form>
  );
}
